import {apiPost} from "../../../../services/apiClient";
import {toast} from "react-toastify";

export const stringToAddress = (stringAddress, setStringAddress, callback) => {
    apiPost('parcels/addresses/suggestions',
        {
            text: stringAddress,
            maxCount: 1,
        })
        .then(data => {
            setStringAddress('');
            if (data.entries && data.entries.length) callback && callback(data.entries[0]);
            else toast.error('Адрес не найден')
        })
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/functions/addresses.js